import { useEffect, useState } from "react";

import { BusinessProfileControllerService } from "@zenith/services/user/services/BusinessProfileControllerService";

import type { TeamRole } from "./permissions";

const toTeamRole = (role?: string): TeamRole => {
  switch ((role ?? "").toLowerCase()) {
    case "manager":
      return "manager";
    case "accountant":
      return "accountant";
    case "cashier":
      return "cashier";
    default:
      // Owners and admins both land here, and both hold every permission.
      return "admin";
  }
};

/**
 * The role of the business context the caller is currently in. Returns "admin"
 * until the profile resolves, which is the permissive default that matches a
 * single-profile sign-in - the app already blocks the pages themselves.
 */
export const useCurrentRole = (): TeamRole => {
  const [role, setRole] = useState<TeamRole>("admin");

  useEffect(() => {
    let isCurrent = true;
    BusinessProfileControllerService.current()
      .then((response) => {
        if (isCurrent) setRole(toTeamRole(response.data?.profile?.role));
      })
      .catch((error) =>
        console.error("Failed to read the current profile role:", error)
      );
    return () => {
      isCurrent = false;
    };
  }, []);

  return role;
};
